import { RegisterClosureManager } from '../../../managers/register-closure-manager'
import { RegisterManager } from '../../../managers/register-manager'
import { $q } from '../../../ng-compat/imports'

/**
 * Controller for the open-register-continue-sale modal.
 *
 * @export
 * @class OpenRegisterContinueSaleController
 */
export class OpenRegisterContinueSaleController {
  private _close: $TSFixMe
  public close: $TSFixMe
  public openingRegister: $TSFixMe
  constructor(
    close: $TSFixMe,
    private registerManager: RegisterManager,
    private registerClosureManager: RegisterClosureManager
  ) {
    'ngInject'

    this._close = close
    this.close = () => this._close($q.reject())
  }

  /**
   * Open the register and set the opening cash float (if cash man is enabled) then close the modal if successful.
   *
   * @method openRegister
   *
   * @param  {Object} cashFloatSettings
   *         The cash movement object for the opening cash float.
   */
  public openRegister(cashFloatSettings: any) {
    this.openingRegister = true
    this.registerClosureManager
      .openRegister(this.registerManager.getActiveRegister(), cashFloatSettings)
      .then(
        () => this._close(),
        () => {
          this.openingRegister = false
        }
      )
  }
}
